import { Yup } from "../../../common/CommonExport";
import { ErrorMessages } from "../../../constants/messagesAndErrors";

export const CreateDepartmentSchema = Yup.object({
  departmentName: Yup.string().required(ErrorMessages.departmentName),
  hod: Yup.string().required(ErrorMessages.hod),
  email: Yup.string().email(ErrorMessages.invalidEmail).required(ErrorMessages.departmentEmail),
  description: Yup.string().strict(true).required(ErrorMessages.departmentDescription).max(100, ErrorMessages.maxDeptDescriptionAlloed),
  isRosterPlanEligible: Yup.boolean(),
});
export const CreateDesignationSchema = Yup.object({
  department: Yup.string().required(ErrorMessages.departmentName),
  grade: Yup.string().required(ErrorMessages.grade),
  designation: Yup.string().required(ErrorMessages.designation),
  roles: Yup.string().strict(true).required(ErrorMessages.Roles),
  compensation: Yup.string().strict(true).required(ErrorMessages.compensation),
  experience: Yup.string().strict(true).required(ErrorMessages.experience),
  kpiQuestionaires: Yup.array().of(
    Yup.object().shape({
      kpiQuestionaire: Yup.string().required("KRA is required"),
      kpiDescription: Yup.string().required("KPI (Detailed) is required"),
      kpiWeightage: Yup.number().min(0).max(100).required()
    })
  ).min(1, "At least one KPI is required").test('sum-100', 'Total KPI weightage must be 100%', (value) => {
    return value && value.reduce((acc, curr) => acc + (curr.kpiWeightage || 0), 0) === 100;
  }),
});
